import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import cartLogo from '../../assets/cart_icon.png';
import { Link } from 'react-router-dom';
import { getOpenCartItemsThunk } from '../../store/cartItems';

class CartButton extends React.Component {
  componentDidMount() {
    this.props.loadCart();
  }

  render() {
    const count = (this.props.cartItems || []).reduce((total, item) => {
      return total + (parseInt(item.quantity, 10) || 0);
    }, 0);

    return (
      <div className="cart-button-wrap">
        <Button variant="clear" className="cart-icon-btn">
          <Link to="/shopping-cart" aria-label={`Shopping bag${count ? `, ${count} items` : ''}`}>
            <img alt="" src={cartLogo} className="Nav-icon" />
            {count > 0 && <span className="cart-badge">{count > 99 ? '99+' : count}</span>}
          </Link>
        </Button>
      </div>
    );
  }
}

const mapState = (state) => ({
  cartItems: state.cartItems,
});

const mapDispatch = (dispatch) => ({
  loadCart: () => dispatch(getOpenCartItemsThunk()),
});

export default connect(mapState, mapDispatch)(CartButton);
